const News = () => import('./Main')

const route = {
  path: '/news',
  name: 'news',
  meta: {
    title: 'News - A D M A N 2 0 1 9'
  },
  component: News
}

export default route
